import { Injectable } from '@angular/core';

import { SiteTypeEnum } from '../../enums';
import { StrategyAbstractService } from '../strategy-abstract.service';

@Injectable({
  providedIn: 'root',
})
export class TrustpilotService extends StrategyAbstractService {
  constructor() {
    super();
  }

  getType(): number {
    return 15;
  }
  getTypeString(): string {
    return SiteTypeEnum.Trustpilot;
  }
  getAllTasksTypes(): number[] {
    return [40, 41];
  }
  getPublicTaskTypes(): number[] {
    return [40];
  }
  getPrivateTaskTypes(): number[] {
    return [41];
  }
  getTaskTypeString(taskType: number): string {
    const mapping = {
      40: 'trustpilot/service-review',
      41: 'trustpilot/product-review',
    };
    return mapping[taskType];
  }

  getTaskTypeQueueId(taskType: number): string {
    const mapping = {
      40: 'trustpilot-service-review',
      41: 'trustpilot-product-review',
    };
    return mapping[taskType];
  }

  canHaveSurveys(): boolean {
    return false;
  }

  isQuickReplyEnable() {
    return 0;
  }
}
